"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _styled = _interopRequireDefault(require("@emotion/styled"));

var _Container = _interopRequireDefault(require("../../components/Container"));

var _Link = _interopRequireDefault(require("../../components/Link"));

var _Icon = _interopRequireDefault(require("../../components/Icon"));

var _Logo = _interopRequireDefault(require("./Logo"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  } else {
    var newObj = {};

    if (obj != null) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
          var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {};

          if (desc.get || desc.set) {
            Object.defineProperty(newObj, key, desc);
          } else {
            newObj[key] = obj[key];
          }
        }
      }
    }

    newObj.default = obj;
    return newObj;
  }
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var HeaderNode = (0, _styled["default"])('header')(function (_ref) {
  var theme = _ref.theme;
  return _defineProperty({
    label: 'HeaderDesktop',
    backgroundColor: 'white',
    display: 'none'
  }, theme.media.tablet, {
    display: 'block'
  });
});
var HeaderInner = (0, _styled["default"])('div')(function (_ref3) {
  var theme = _ref3.theme;
  return {
    borderBottom: "1px solid ".concat(theme.colors.lightGray)
  };
});
var HeaderDesktopUserContainer = (0, _styled["default"])('div')({
  position: 'relative',
  height: '80px'
});
var HeaderDesktopUserLinksContainer = (0, _styled["default"])('div')(function (_ref4) {
  var isOpen = _ref4.isOpen;
  return {
    backgroundColor: 'white',
    boxShadow: 'rgba(0, 0, 0, 0.1) 1px 1px 15px 0px',
    position: 'absolute',
    padding: '10px',
    right: '0',
    top: '60px',
    opacity: isOpen ? 1 : 0,
    transition: isOpen ? 'transform 0.3s, opacity 0.1s ease 0.1s' : 'transform 0.1s ease 0.1s, opacity 0.3s',
    transform: isOpen ? 'translateY(5px)' : 'translateY(0)',
    pointerEvents: isOpen ? 'auto' : 'none',
    borderRadius: '3px',
    zIndex: '10',
    width: '200px'
  };
});
var UserIcon = (0, _styled["default"])(_Icon["default"])(function (_ref5) {
  var theme = _ref5.theme;
  return {
    label: 'UserIcon',
    display: 'block',
    padding: '10px',
    marginTop: '20px',
    userSelect: 'none',
    border: "1px solid ".concat(theme.colors.lightGray),
    borderRadius: '3px',
    backgroundColor: 'white',
    transition: 'background-color 0.2s',
    cursor: 'pointer',
    '&:hover': {
      backgroundColor: theme.colors.lightGray
    }
  };
});
var UserLinkWrapper = (0, _styled["default"])(_Link["default"])({
  label: 'UserLinkWrapper',
  display: 'block',
  padding: '5px',
  fontSize: '16px',
  marginBottom: '10px',
  '&:hover': {
    textDecoration: 'underline'
  }
});

var HeaderDesktopUser =
/*#__PURE__*/
function (_React$Component) {
  _inherits(HeaderDesktopUser, _React$Component);

  function HeaderDesktopUser(props) {
    var _this;

    _classCallCheck(this, HeaderDesktopUser);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(HeaderDesktopUser).call(this, props));
    _this.onUserClick = _this.onUserClick.bind(_assertThisInitialized(_this));
    _this.state = {
      isOpen: false
    };
    return _this;
  }

  _createClass(HeaderDesktopUser, [{
    key: "onUserClick",
    value: function onUserClick() {
      this.setState(function (state) {
        return {
          isOpen: !state.isOpen
        };
      });
    }
  }, {
    key: "render",
    value: function render() {
      var user = this.props.user;
      return _react["default"].createElement(HeaderDesktopUserContainer, null, _react["default"].createElement(UserIcon, {
        name: "user",
        onClick: this.onUserClick
      }), _react["default"].createElement(HeaderDesktopUserLinksContainer, {
        isOpen: this.state.isOpen
      }, user.links.map(function (link, i) {
        return _react["default"].createElement(UserLinkWrapper, {
          key: i,
          href: link.url
        }, link.label);
      }), _react["default"].createElement(UserLinkWrapper, {
        href: user.disconnect.url
      }, user.disconnect.label)));
    }
  }]);

  return HeaderDesktopUser;
}(_react["default"].Component);

var HeaderContainer = (0, _styled["default"])(_Container["default"])({
  label: 'HeaderContainer',
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center'
});

var HeaderDesktop = function HeaderDesktop(_ref6) {
  var logo = _ref6.logo,
      menu = _ref6.menu,
      user = _ref6.user;
  return _react["default"].createElement(HeaderNode, null, _react["default"].createElement(HeaderInner, null, _react["default"].createElement(HeaderContainer, null, _react["default"].createElement(_Logo["default"], _extends({}, logo, {
    height: 80
  })), _react["default"].createElement(DesktopList, {
    links: menu
  }), user && user.links && user.links.length > 0 ? _react["default"].createElement(HeaderDesktopUser, {
    user: user
  }) : null)));
};

var Nav = (0, _styled["default"])('nav')({
  marginLeft: '10px',
  position: 'relative',
  alignSelf: 'flex-end',
  flex: 1,
  '> ul': {
    marginBottom: 0
  }
});
var Ul = (0, _styled["default"])('ul')({
  width: '100%',
  height: '80px',
  marginBottom: 0,
  padding: 0
});
var Li = (0, _styled["default"])('li')({
  "float": 'left',
  display: 'table',
  height: '100%',
  marginLeft: '20px',
  marginRight: '20px',
  marginBottom: 0
});
var InnerLink = (0, _styled["default"])(_Link["default"])(function (_ref7) {
  var theme = _ref7.theme;
  return {
    display: 'table-cell',
    verticalAlign: 'middle',
    fontWeight: 600,
    textTransform: 'uppercase',
    color: theme.colors.primary,
    textDecoration: 'none'
  };
});
var Stroke = (0, _styled["default"])('div')(function (_ref8) {
  var hasStroke = _ref8.hasStroke,
      strokeLeft = _ref8.strokeLeft,
      _strokeWidth = _ref8._strokeWidth,
      theme = _ref8.theme;
  return {
    position: 'absolute',
    backgroundColor: theme.colors.primary,
    height: hasStroke ? '3px' : '0px',
    left: "".concat(strokeLeft || 0, "px"),
    width: "".concat(_strokeWidth || 0, "px"),
    bottom: 0,
    transition: 'left 0.2s cubic-bezier(0.165, 0.84, 0.44, 1), width 0.1s, height 0.1s'
  };
});

var DesktopList =
/*#__PURE__*/
function (_Component) {
  _inherits(DesktopList, _Component);

  function DesktopList(props) {
    var _this2;

    _classCallCheck(this, DesktopList);

    _this2 = _possibleConstructorReturn(this, _getPrototypeOf(DesktopList).call(this, props));
    _this2.onMouseEnter = _this2.onMouseEnter.bind(_assertThisInitialized(_this2));
    _this2.onMouseLeave = _this2.onMouseLeave.bind(_assertThisInitialized(_this2));
    _this2.state = {
      hasStroke: false,
      _strokeWidth: 0,
      strokeLeft: 0
    };
    return _this2;
  }

  _createClass(DesktopList, [{
    key: "onMouseEnter",
    value: function onMouseEnter(e) {
      this.setState({
        hasStroke: true,
        strokeLeft: e.currentTarget.offsetLeft,
        _strokeWidth: e.currentTarget.offsetWidth
      });
    }
  }, {
    key: "onMouseLeave",
    value: function onMouseLeave() {
      this.setState({
        hasStroke: false
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;

      var links = this.props.links;
      var _this$state = this.state,
          hasStroke = _this$state.hasStroke,
          strokeLeft = _this$state.strokeLeft,
          _strokeWidth = _this$state._strokeWidth;
      return _react["default"].createElement(Nav, null, _react["default"].createElement(Ul, {
        onMouseLeave: this.onMouseLeave
      }, links.map(function (l, i) {
        return _react["default"].createElement(Li, {
          key: i,
          onMouseEnter: _this3.onMouseEnter
        }, _react["default"].createElement(InnerLink, {
          href: l.url
        }, l.label));
      })), _react["default"].createElement(Stroke, {
        hasStroke: hasStroke,
        strokeLeft: strokeLeft,
        _strokeWidth: _strokeWidth
      }));
    }
  }]);

  return DesktopList;
}(_react.Component);

var _default = HeaderDesktop;
exports["default"] = _default;